import React, { useEffect, useState } from 'react'
import { Row, Col, Button } from "reactstrap"
import CardPeriodosProyeccionHE from './CardPeriodosProyeccionHE'
import { DetalleParametrosProyeccionHE, DetalleParametrosRegimenProyeccionHE } from '../TypesParametrosHorasExtras'
import CardNroHorasProyeccion from './CardNroHorasProyeccion'
import { useParametrosHorasExtrasContext } from 'Context/ParametrosHorasExtrasContext'
import { PruebaSolucion2 } from 'functions/DatesFunctions'
import { ActualizarParametrosPeriodoProyeccionHE, ConsultarDetalleParametrosAnio, CrearParametrosPeriodoAnio } from '../FunctionsParametrosHE'
import { showAlert } from '../Actividades/ActividadesHorasExtras'
import Cargando from 'components/Varios/Cargando'
import CardAnioEjecucion from '../CardAnioEjecucion'

type PropsParametrosProy = {
    parametrosProyeccion: DetalleParametrosProyeccionHE | null | undefined,
    anioParametros: number | undefined
}

export function NormalizeInformacionParametros(copiaInformacionGeneral: DetalleParametrosProyeccionHE) {
    if (copiaInformacionGeneral.fechainicioproyeccion !== null && copiaInformacionGeneral.fechafinproyeccion !== null) {

        const newFechaInicioProyeccion = PruebaSolucion2(copiaInformacionGeneral.fechainicioproyeccion)
        const newFechaFinProyeccion = PruebaSolucion2(copiaInformacionGeneral.fechafinproyeccion)

        if (newFechaInicioProyeccion !== "") {
            copiaInformacionGeneral.fechainicioproyeccion = newFechaInicioProyeccion
        }
        if (newFechaFinProyeccion !== "") {
            copiaInformacionGeneral.fechafinproyeccion = newFechaFinProyeccion
        }

    }

    if (copiaInformacionGeneral.fechainicioasigpresupGPE !== null && copiaInformacionGeneral.fechafinasigpresupGPE !== null) {

        const newFechaInicioAsignacion = PruebaSolucion2(copiaInformacionGeneral.fechainicioasigpresupGPE)
        const newFechaFinAsignacion = PruebaSolucion2(copiaInformacionGeneral.fechafinasigpresupGPE)

        if (newFechaInicioAsignacion !== "") {
            copiaInformacionGeneral.fechainicioasigpresupGPE = newFechaInicioAsignacion
        }
        if (newFechaFinAsignacion !== "") {
            copiaInformacionGeneral.fechafinasigpresupGPE = newFechaFinAsignacion
        }

    }

    if (copiaInformacionGeneral.fechainicioproyeccionextr !== null && copiaInformacionGeneral.fechafinproyeccionextr !== null) {

        const newFechaInicioProyExtr = PruebaSolucion2(copiaInformacionGeneral.fechainicioproyeccionextr)
        const newFechaFinProyExtr = PruebaSolucion2(copiaInformacionGeneral.fechafinproyeccionextr)

        if (newFechaInicioProyExtr !== "") {
            copiaInformacionGeneral.fechainicioproyeccionextr = newFechaInicioProyExtr
        }
        if (newFechaFinProyExtr !== "") {
            copiaInformacionGeneral.fechafinproyeccionextr = newFechaFinProyExtr
        }

    }

}


export default function ParametrosProyeccion(props: PropsParametrosProy) {

    const fechaActual = new Date();
    const anioActualDefault = fechaActual.getFullYear();

    const { parametrosProyeccion, anioParametros } = props;

    const [anioConsulta, setanioConsulta] = useState<number>(anioParametros??anioActualDefault)


    const [informacionGeneralParametros, setinformacionGeneralParametros] = useState<DetalleParametrosProyeccionHE | null | undefined>(parametrosProyeccion)


    const {
        setguardandoParametro,
        setconsultandoParametrosAnio,
        setparametrosHorasRegimen,
        guardandoParametro,
        parametrosHorasRegimen,
        setcreandoParametros,
        creandoParametros
    } = useParametrosHorasExtrasContext()

    function OnChangeFechas(informacionGeneralParametros: DetalleParametrosProyeccionHE | null | undefined, tipo: string, value: string) {
        if (value !== "") {
            if (!informacionGeneralParametros && anioParametros) {

                var nuevosParametros: DetalleParametrosProyeccionHE = {
                    anio: anioParametros,
                    listadoparametroshorasregimen: [],
                    fechainicioproyeccion: null,
                    fechafinproyeccion: null,
                    fechainicioasigpresupGPE: null,
                    fechafinasigpresupGPE: null,
                    fechainicioproyeccionextr: null,
                    fechafinproyeccionextr: null

                }

                if (tipo === "proyeccioninicio") {
                    nuevosParametros.fechainicioproyeccion = value
                }
                else if (tipo === "proyeccionfin") {
                    nuevosParametros.fechafinproyeccion = value
                }

                setinformacionGeneralParametros(nuevosParametros);

            }
            else if (informacionGeneralParametros) {

                if (tipo === "proyeccioninicio") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechainicioproyeccion: value })
                }
                else if (tipo === "proyeccionfin") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechafinproyeccion: value })
                }
                else if (tipo === "asignacioninicio") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechainicioasigpresupGPE: value })

                }
                else if (tipo === "asignacionfin") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechafinasigpresupGPE: value })

                }
                else if (tipo === "proyeccioninicioextr") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechainicioproyeccionextr: value })
                }
                else if (tipo === "proyeccionfinextr") {
                    setinformacionGeneralParametros({ ...informacionGeneralParametros, fechafinproyeccionextr: value })
                }
            }

        }
    }

    async function ConsultarDetalle(anioSeleccionado: number) {
        const detalleParametros = await ConsultarDetalleParametrosAnio(anioSeleccionado);
        if (detalleParametros.status === 200 && detalleParametros.dataResponse) {

            
            setinformacionGeneralParametros(detalleParametros.dataResponse.parametrosProyeccion)
            if (detalleParametros.dataResponse.parametrosProyeccion) {
                setparametrosHorasRegimen(detalleParametros.dataResponse.parametrosProyeccion.listadoparametroshorasregimen)
            }
            
            else {
                setparametrosHorasRegimen(null)
            }
        }
        else if (detalleParametros.status === 204) {
            setinformacionGeneralParametros(null)
            setparametrosHorasRegimen(null)

        }
        else if(detalleParametros.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al consultar detalle de parámetros de proyección"
            showAlert(detalleParametros.errorMessage ?? mensajeDefault, false)
        }
    }

    async function ActualizarParametros(informacionGeneralParametros: DetalleParametrosProyeccionHE | null | undefined, parametrosHoras: DetalleParametrosRegimenProyeccionHE[] | null) {
        if (informacionGeneralParametros && parametrosHoras) {
            setguardandoParametro(true);
            var copiaInformacionGeneral: DetalleParametrosProyeccionHE = { ...informacionGeneralParametros };
            NormalizeInformacionParametros(copiaInformacionGeneral);

            if (parametrosHoras != null) {

                if (parametrosHoras.find(hr => (!hr.horasextraordinarias) && !hr.horassuplementarias && !hr.horassuplyextr) !== undefined) {
                    showAlert("Debe indicar los valores de nro de Horas para poder guardar los parámetros", false);
                    setguardandoParametro(false);
                    return
                }

                copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHoras;
            }

            const respuesta = await ActualizarParametrosPeriodoProyeccionHE(copiaInformacionGeneral);
            if (respuesta.status === 200 || respuesta.status === 204) {

                showAlert("Se han actualizado los parámetros sin novedad", true)
                await ConsultarDetalle(informacionGeneralParametros.anio);

            }
            else if(respuesta.status === 401){
                showAlert("Su usuario no se encuentra autorizado para realizar esta acción", false)
            }
            else {
                const mensajeDefault = "Ha ocurrido un inconveniente al intentar actualizar los parámetros"

            }

            setguardandoParametro(false);

        }
        else {
            showAlert("Debe indicar el período de proyección y los valores de nro de Horas para poder guardar los parámetros", false)
        }
    }


    async function CrearParametros(informacionGeneralParametros: DetalleParametrosProyeccionHE | null | undefined, parametrosHoras: DetalleParametrosRegimenProyeccionHE[] | null) {

        if (informacionGeneralParametros) {
            setcreandoParametros(true)

            var copiaInformacionGeneral = { ...informacionGeneralParametros };


            NormalizeInformacionParametros(copiaInformacionGeneral);

            if (parametrosHorasRegimen !== null) {
                copiaInformacionGeneral.listadoparametroshorasregimen = parametrosHorasRegimen;
            }

            const respuesta = await CrearParametrosPeriodoAnio(copiaInformacionGeneral);
            if (respuesta.status === 200 || respuesta.status === 204) {
                showAlert("Se han agregado/actualizado los parámetros sin novedad", true)

            }
            else if(respuesta.status === 401){
                showAlert("Su usuario no se encuentra autorizado para realizar esta acción", false)
            }
            else {
                const mensajeDefault = "Ha ocurrido un evento inesperado. Intente más tarde."
                showAlert(respuesta.errorMessage ?? mensajeDefault, false)

            }

            setcreandoParametros(false)
            ConsultarDetalle(informacionGeneralParametros.anio);
        }
        else {
            showAlert("Debe indicar el período de proyección para poder guardar los parámetros", false)
        }
    }

    

    return (
        <React.Fragment>
            {/* <Row>
                <Col xl={12}>
                    {informacionGeneralParametros && <>
                        <div>BORRAR ESTO, ESTE ES EL STATE Y SE VERIFICA SI SE ACTUALIZA</div>
                        <div>periodo proy</div>

                        <div>{informacionGeneralParametros.fechainicioproyeccion?.toString()}</div>
                        <div>{informacionGeneralParametros.fechafinproyeccion?.toString()}</div>
                        <div>ASIG PRESUP</div>
                        <div>{informacionGeneralParametros.fechainicioasigpresupGPE?.toString()}</div>
                        <div>{informacionGeneralParametros.fechafinasigpresupGPE?.toString()}</div>
                        <div>PROY EXTR</div>
                        <div>{informacionGeneralParametros.fechainicioproyeccionextr?.toString()}</div>
                        <div>{informacionGeneralParametros.fechafinproyeccionextr?.toString()}</div>
                    </>}
                </Col>
            </Row> */}

            {/* <CardAnioEjecucion
                anio={informacionGeneralParametros?.anio}
                listadoAnios={MapearListadoAniosOpciones(informacionGeneralParametros?.listadoaniosdisponibles)}
                onChangeAnio={(anio: number) => ConsultarDetalle(anio)}
            /> */}

            <Row className="mt-4">
                <Col xl={12}>
                    <div className="tituloTipoParametroHE">{"PROYECCIÓN " + props.anioParametros}</div>
                </Col>
            </Row>

            {
                (guardandoParametro || creandoParametros) &&
                <Row>
                    <Col xl={12}>
                        <Cargando mensaje='Guardando parametros' />
                    </Col>
                </Row>
            }
            {
                (!guardandoParametro && !creandoParametros) &&
                <React.Fragment>
                    <Row>
                        <Col xl={6}>
                            <CardPeriodosProyeccionHE
                                parametros={informacionGeneralParametros}
                                onChangeFecha={(tipo: string, value: string) => OnChangeFechas(informacionGeneralParametros, tipo, value)}
                            />
                        </Col>
                        <Col xl={6} className={""}>
                            <CardNroHorasProyeccion
                                parametros={informacionGeneralParametros}
                            />
                        </Col>



                    </Row>
                    <Row className="justify-content-center">
                        <Col xl={12}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                {
                                    informacionGeneralParametros?.valoresConsultados ?
                                        <Button
                                            onClick={() => ActualizarParametros(informacionGeneralParametros, parametrosHorasRegimen)}
                                            color="secondary"
                                            disabled={guardandoParametro}
                                        >
                                            Guardar
                                        </Button>
                                        :
                                        <Button
                                            onClick={() => CrearParametros(informacionGeneralParametros, parametrosHorasRegimen)}
                                            color="secondary"
                                            disabled={creandoParametros}
                                        >
                                            Guardar
                                        </Button>
                                }


                            </div>

                        </Col>
                    </Row>
                </React.Fragment>
            }

        </React.Fragment>
    )
}
